module.exports = __webpack_public_path__ + "static/media/FirstContent.ce5471ca.png";